"use client";
import React, { useState } from "react";

export default function Newslatter({ footerNewsletterText }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);


  const handleSubscribe = async () => {
    if (!email || !email.includes("@")) {
      setMsg("Please enter a valid email");
      return;
    }

    try {
      setLoading(true);
      setMsg("");

      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subscribeUser: email,   // this goes to Google Sheet
        }),
      });

      const data = await res.json();

      if (data.ok) {
        alert("✅ This email has been successfully subscribed!");
        setEmail("");
      }
      else {
        setMsg("❌ Something went wrong");
      }
    } catch (err) {
      setMsg("❌ Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="w-full max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        <div className="bg-[#072233] py-8 mx-auto px-6 flex flex-col-reverse md:flex-row justify-between items-center gap-6">

          {/* Left Text */}
          <p className="subsribe-writing text-white text-center md:text-left">
            {footerNewsletterText}
          </p>

          {/* Right Input + Button */}
          <div className="flex w-full md:w-auto justify-center md:justify-end">
            <input
              type="email"
              placeholder="Enter your email address"
              className="w-full md:w-72 px-4 py-3 bg-white text-black footer-link focus:outline-none outline-none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <div className="px-3 py-3 bg-[var(--background)]">
              <button
                onClick={handleSubscribe}
                disabled={loading}
                className={`px-6 py-3 bg-[var(--color-primary)] text-black hover:text-white font-semibold footer-link  transition-all disabled:opacity-60 ${isValidEmail ? "cursor-pointer" : "cursor-not-allowed"}  `}
              >
                {loading ? "Sending..." : "Subscribe"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
